import { PROJECT_STATUS_CODES } from '../constants/ProjectStatus';

export const isProjectActive = (projectStatus) => {
  return (
    projectStatus === PROJECT_STATUS_CODES.COMPLETED ||
    projectStatus === PROJECT_STATUS_CODES.REACTIVE_PENDING_IN_PROGRESS ||
    projectStatus === PROJECT_STATUS_CODES.UNARCHIVING_IN_PROGRESS ||
    projectStatus === PROJECT_STATUS_CODES.UNARCHIVING_PENDING_IN_PROGRESS ||
    projectStatus === PROJECT_STATUS_CODES.ARCHIVING_PENDING_NEEDS_APPROVAL ||
    projectStatus === PROJECT_STATUS_CODES.INACTIVE_PENDING_NEEDS_APPROVAL
  );
};

export const isProjectCreationInProgress = (projectStatus) => {
  return (
    projectStatus === PROJECT_STATUS_CODES.IN_PROGRESS ||
    projectStatus === PROJECT_STATUS_CODES.MIGRATION_COMPLETED
  );
};

export const isProjectDisabled = (projectStatus) => {
  return projectStatus !== PROJECT_STATUS_CODES.COMPLETED;
};

export const isErrorStatus = (projectStatus) => {
  return projectStatus === PROJECT_STATUS_CODES.ERROR_STATUS;
};

export const isProjectReactivePendingInProgress = (projectStatus) => {
  return projectStatus === PROJECT_STATUS_CODES.REACTIVE_PENDING_IN_PROGRESS;
};

export const isProjectUnarchivingPendingInProgress = (projectStatus) => {
  return projectStatus === PROJECT_STATUS_CODES.UNARCHIVING_PENDING_IN_PROGRESS;
};

export const isProjectInactive = (projectState) => {
  return (
    projectState === PROJECT_STATUS_CODES.INACTIVE ||
    projectState === PROJECT_STATUS_CODES.INACTIVE_PENDING_IN_PROGRESS ||
    projectState === PROJECT_STATUS_CODES.REACTIVE_PENDING_NEEDS_APPROVAL ||
    projectState ===
      PROJECT_STATUS_CODES.ARCHIVING_PENDING_FROM_INACTIVE_NEEDS_APPROVAL
  );
};

export const isProjectInactivePendingInProgress = (projectStatus) => {
  return projectStatus === PROJECT_STATUS_CODES.INACTIVE_PENDING_IN_PROGRESS;
};

export const isProjectArchived = (projectState) => {
  return (
    projectState === PROJECT_STATUS_CODES.ARCHIVED ||
    projectState === PROJECT_STATUS_CODES.ARCHIVING_IN_PROGRESS ||
    projectState === PROJECT_STATUS_CODES.ARCHIVING_PENDING_IN_PROGRESS ||
    projectState === PROJECT_STATUS_CODES.UNARCHIVING_PENDING_NEEDS_APPROVAL
  );
};

export const isProjectPaused = (projectStatus) => {
  return projectStatus === PROJECT_STATUS_CODES.INACTIVE;
};

export const isProjectArchiveComplete = (projectStatus) => {
  return projectStatus === PROJECT_STATUS_CODES.ARCHIVED;
};

export const isProjectActivateComplete = (projectStatus) => {
  return projectStatus === PROJECT_STATUS_CODES.COMPLETED;
};

export const isProjectArchivingInProgress = (projectStatus) => {
  return projectStatus === PROJECT_STATUS_CODES.ARCHIVING_IN_PROGRESS;
};

export const isProjectUnArchivingInProgress = (projectStatus) => {
  return projectStatus === PROJECT_STATUS_CODES.UNARCHIVING_IN_PROGRESS;
};

export const isProjectArchivingPendingInProgress = (projectStatus) => {
  return projectStatus === PROJECT_STATUS_CODES.ARCHIVING_PENDING_IN_PROGRESS;
};

export const isProjectInPendingState = (projectStatus) => {
  return (
    isProjectArchivingInProgress(projectStatus) ||
    isProjectUnArchivingInProgress(projectStatus) ||
    isProjectUnarchivingPendingInProgress(projectStatus) ||
    isProjectReactivePendingInProgress(projectStatus) ||
    isProjectInactivePendingInProgress(projectStatus) ||
    isProjectArchivingPendingInProgress(projectStatus)
  );
};

export const isProjectReadOnly = (projectState) => {
  return isProjectInactive(projectState) || isProjectArchived(projectState);
};
